import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import {SimpleUser} from "../../services/user.service";
import { AvatarComponent } from '../../components/avatar/avatar.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-show-user',
    templateUrl: './show-user.component.html',
    styleUrls: ['./show-user.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FaIconComponent, AvatarComponent]
})
export class ShowUserComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: {user: SimpleUser}) { }



}
